import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "../../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationStaticCenterBookingStepConfigurations,
  screeningStepConfigurations
} from "../../App/Compositions/StepConfigurations";
import { Flow } from "../../Types/IFlow";

const noConfirmationRebookFlowName = "NoConfirmationRebookFlow";

/** The flow that a rebook guest should experience when booking without a confirmation step. */
class NoConfirmationRebookFlow extends Flow {
  static readonly flowName = noConfirmationRebookFlowName;

  constructor(isPatientPreQualified: boolean) {
    isPatientPreQualified
      ? super(noConfirmationRebookFlowName, { ...noConfirmationStaticCenterBookingStepConfigurations }, [
          ...NoConfirmationPreQualifiedPatientNavigatorConfiguration
        ])
      : super(
          noConfirmationRebookFlowName,
          { ...screeningStepConfigurations, ...noConfirmationStaticCenterBookingStepConfigurations },
          [...NoConfirmationDefaultNavigatorConfiguration]
        );
  }
}

export default NoConfirmationRebookFlow;
